import React, { useState } from 'react';

const WaitlistTerms = (props) => {
  const [hidden, setHidden] = useState(true);
  const maxLength = 104;

  const toggleHidden = () => {
    if (hidden) {
      setHidden(false);
    } else {
      setHidden(true);
    }
  };

  return (
    <div>
      {props.isInternational && (
        <div className="WaitlistModal__terms">
          <div className="WaitlistModal__row">
            <input type="checkbox" name="waitlist_marketing" />
            <span onClick={toggleHidden}>
              <span className="WaitlistModal__terms-wrapper">
                {props.terms.substr(0, maxLength).trim()}
                {hidden && (
                  <span>
                    <span>... </span>
                    <a className="WaitlistModal__terms-expand" onClick={() => setHidden(false)}>
                      more
                    </a>
                  </span>
                )}
                <span className={hidden ? 'WaitlistModal__terms--hide' : 'WaitlistModal__terms--show'}>
                  {' '}
                  newsletter with special offers and fashion trends delivered daily to my inbox. I understand I can
                  unsubscribe at any time. *See our{' '}
                  <a href="https://www.windsorstore.com/pages/contest-terms-conditions">
                    Terms and Conditions
                  </a> and <a href="https://www.windsorstore.com/pages/privacy-policy">Privacy Policy</a> for more
                  details. Windsor, Inc., 9603 John St., Santa Fe Springs, CA 90670, (888) 494-6376*
                </span>
              </span>
            </span>
          </div>
        </div>
      )}
      {!props.isInternational && (
        <p className="WaitlistModal__terms" onClick={toggleHidden}>
          {props.terms.substr(0, maxLength).trim()}
          {hidden && (
            <span>
              <span>... </span>
              <a className="WaitlistModal__terms-expand" onClick={() => setHidden(false)}>
                more
              </a>
            </span>
          )}
          <span className={hidden ? 'WaitlistModal__terms--hide' : 'WaitlistModal__terms--show'}>
            tter with special offers and fashion trends delivered daily to my inbox. I understand I can unsubscribe at
            any time. *See our{' '}
            <a href="https://www.windsorstore.com/pages/contest-terms-conditions">Terms and Conditions</a> and{' '}
            <a href="https://www.windsorstore.com/pages/privacy-policy">Privacy Policy</a> for more details. Windsor,
            Inc., 9603 John St., Santa Fe Springs, CA 90670, (888) 494-6376*
          </span>
        </p>
      )}
    </div>
  );
};

export default WaitlistTerms;
